'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { IconArrowForward } from '@/app/components/icons/ui-actions/icon-arrow-forward';
import { SPARTAN_PRODUCT_ENGINE_LABELS } from '@/app/lcv/components/sections/spartan/products/engine/constants';
import { getEngineCtaColor, getEngineIndicator, getEngineTabsVariant } from '@/app/lcv/components/sections/spartan/products/engine/styles';
import styles from '@/app/lcv/components/sections/spartan/products/engine/styles.module.css';
import { SPARTAN_PRODUCT_ENGINE_DATA_GA, SPARTAN_PRODUCT_ENGINE_TRACKING } from '@/app/lcv/components/sections/spartan/products/engine/tracking';
import { SpartanProductEngineAnimatedLogo } from '@/app/lcv/components/sections/spartan/products/engine/view/card/animated-logo';
import type { SpartanProductEngineCardProps } from '@/app/lcv/components/sections/spartan/products/engine/view/card/types';
import { SpartanProductEnginePanel } from '@/app/lcv/components/sections/spartan/products/engine/view/panel';
import { SPARTAN_PRODUCT_BUTTON_RADIUS_CLASS_NAME } from '@/app/lcv/components/sections/spartan/products/shared/icon-button';
import { getSpartanRevealItemProps, SPARTAN_REVEAL_ROLE } from '@/app/lcv/components/sections/spartan/products/shared/reveal';
import { SPARTAN_PRODUCTS_EVENT_NAME } from '@/app/lcv/components/sections/spartan/products/shared/tracking';
import arrowStyles from '@/app/lcv/components/sections/spartan/shared/arrow-motion.module.css';
import { SpartanTabs } from '@/app/lcv/components/sections/spartan/shared/tabs';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
export const SpartanProductEngineCard = t0 => {
  const $ = _c(55);
  const {
    engines,
    selectedIndex,
    tabIndex,
    selectedEngine,
    cta,
    theme: t1,
    shouldLoadMedia: t2,
    onSelectIndex
  } = t0;
  const theme = t1 === undefined ? "dark" : t1;
  const shouldLoadMedia = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== onSelectIndex) {
    t3 = value => {
      onSelectIndex(Number(value));
    };
    $[0] = onSelectIndex;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleTabChange = t3;
  const {
    logo
  } = selectedEngine;
  const tabEngine = engines[tabIndex] ?? selectedEngine;
  const t4 = tabEngine.tabPalette ?? tabEngine.stagePalette;
  let t5;
  if ($[2] !== t4) {
    t5 = getEngineIndicator(t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const indicator = t5;
  const inactiveTabClassName = tabEngine.stagePalette === "lime" && indicator.tone === "orange" ? "text-gray-100 hover:text-white" : undefined;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div aria-hidden={true} className={cn("pointer-events-none absolute inset-0 rounded-b-lg lg:rounded-md", styles.cardOverlay)} {...getSpartanRevealItemProps({
      order: 0,
      role: SPARTAN_REVEAL_ROLE.fade
    })} />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn(styles.logoMotion, "mx-auto w-full max-w-101");
    t8 = getSpartanRevealItemProps({
      order: 1,
      role: SPARTAN_REVEAL_ROLE.fade
    });
    $[5] = t7;
    $[6] = t8;
  } else {
    t7 = $[5];
    t8 = $[6];
  }
  const t9 = selectedEngine.title;
  let t10;
  if ($[7] !== selectedIndex) {
    t10 = SPARTAN_PRODUCT_ENGINE_TRACKING.itemLogo(selectedIndex);
    $[7] = selectedIndex;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const t11 = shouldLoadMedia ? "eager" : "lazy";
  let t12;
  if ($[9] !== logo || $[10] !== selectedEngine.title || $[11] !== t10 || $[12] !== t11) {
    t12 = <div className={t7} {...t8}><SpartanProductEngineAnimatedLogo logo={logo} alt={t9} testId={t10} loading={t11} /></div>;
    $[9] = logo;
    $[10] = selectedEngine.title;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== engines || $[15] !== handleTabChange || $[16] !== inactiveTabClassName || $[17] !== indicator || $[18] !== tabIndex || $[19] !== theme) {
    t13 = engines.length > 1 ? <div {...getSpartanRevealItemProps({
      order: 2,
      role: SPARTAN_REVEAL_ROLE.fade
    })}><SpartanTabs variant={getEngineTabsVariant(theme)} indicatorKind={indicator.kind} indicatorTone={indicator.tone} showTrackStroke={false} aria-label={SPARTAN_PRODUCT_ENGINE_LABELS.engineTabs} value={String(tabIndex)} onChange={handleTabChange} items={engines.map(_temp)} itemClassName={inactiveTabClassName} selectedItemClassName={inactiveTabClassName ? "text-white" : undefined} itemTestIdPrefix={SPARTAN_PRODUCT_ENGINE_TRACKING.tabPrefix} tracking={{
        eventName: SPARTAN_PRODUCTS_EVENT_NAME,
        group: SPARTAN_PRODUCT_ENGINE_DATA_GA.section,
        value: SPARTAN_PRODUCT_ENGINE_DATA_GA.tab
      }} {...createDataAttributes({
        test: SPARTAN_PRODUCT_ENGINE_TRACKING.tabs
      })} /></div> : null;
    $[14] = engines;
    $[15] = handleTabChange;
    $[16] = inactiveTabClassName;
    $[17] = indicator;
    $[18] = tabIndex;
    $[19] = theme;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = cn(styles.switchStack, "grid");
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const t15 = engines.length > 1 ? 3 : 2;
  let t16;
  if ($[22] !== t15) {
    t16 = getSpartanRevealItemProps({
      order: t15,
      role: SPARTAN_REVEAL_ROLE.copy
    });
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== engines || $[25] !== selectedIndex || $[26] !== theme) {
    let t18;
    if ($[28] !== selectedIndex || $[29] !== theme) {
      t18 = (engine_0, index_0) => {
        const isActive = index_0 === selectedIndex;
        return <div key={engine_0.engineKey} className={cn("col-start-1 row-start-1", !isActive && "pointer-events-none invisible")} aria-hidden={!isActive}><SpartanProductEnginePanel engine={engine_0} index={index_0} theme={theme} active={isActive} /></div>;
      };
      $[28] = selectedIndex;
      $[29] = theme;
      $[30] = t18;
    } else {
      t18 = $[30];
    }
    t17 = engines.map(t18);
    $[24] = engines;
    $[25] = selectedIndex;
    $[26] = theme;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[31] !== t16 || $[32] !== t17) {
    t18 = <div className={t14} {...t16}>{t17}</div>;
    $[31] = t16;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  const t19 = engines.length > 1 ? 4 : 3;
  let t20;
  if ($[34] !== t19) {
    t20 = getSpartanRevealItemProps({
      order: t19,
      role: SPARTAN_REVEAL_ROLE.fade
    });
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  const t21 = cta.href;
  let t22;
  if ($[36] !== theme) {
    t22 = getEngineCtaColor(theme);
    $[36] = theme;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = createDataAttributes({
      test: SPARTAN_PRODUCT_ENGINE_TRACKING.cta
    });
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== cta.href) {
    t24 = createDataGA({
      eventName: SPARTAN_PRODUCTS_EVENT_NAME,
      group: SPARTAN_PRODUCT_ENGINE_DATA_GA.section,
      value: SPARTAN_PRODUCT_ENGINE_DATA_GA.cta,
      click: true,
      text: SPARTAN_PRODUCT_ENGINE_LABELS.detail,
      url: cta.href
    });
    $[39] = cta.href;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  let t26;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <span className={cn("block size-full", arrowStyles.arrow)}><IconArrowForward /></span>;
    t26 = cn(styles.cta, arrowStyles.trigger, "px-0 [&_i]:size-5", SPARTAN_PRODUCT_BUTTON_RADIUS_CLASS_NAME);
    $[41] = t25;
    $[42] = t26;
  } else {
    t25 = $[41];
    t26 = $[42];
  }
  let t27;
  if ($[43] !== cta.href || $[44] !== t22 || $[45] !== t24) {
    t27 = <Button href={t21} color={t22} variant="tertiary" size="sm" width="auto" {...t23} {...t24} iconAfter={t25} className={t26}>{SPARTAN_PRODUCT_ENGINE_LABELS.detail}</Button>;
    $[43] = cta.href;
    $[44] = t22;
    $[45] = t24;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== t20 || $[48] !== t27) {
    t28 = <div className="mt-auto self-start" {...t20}>{t27}</div>;
    $[47] = t20;
    $[48] = t27;
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== t12 || $[51] !== t13 || $[52] !== t18 || $[53] !== t28) {
    t29 = <div className="xs:p-6 relative isolate z-10 flex h-full w-full flex-col gap-6 overflow-visible rounded-b-lg p-4 lg:ml-auto lg:max-w-116 lg:rounded-md">{t6}<div className="relative flex h-full min-w-0 flex-col gap-4 md:gap-6">{t12}{t13}{t18}{t28}</div></div>;
    $[50] = t12;
    $[51] = t13;
    $[52] = t18;
    $[53] = t28;
    $[54] = t29;
  } else {
    t29 = $[54];
  }
  return t29;
};
function _temp(engine, index) {
  return {
    label: engine.tabLabel,
    value: String(index)
  };
}